'use client';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import { Text } from '@/ui-components/atoms/Text/Text';
import NoGames from '@/components/contentful/ContextualComponent/Sports/NoGames';
import sportsStyles from '@/components/contentful/ContextualComponent/Sports/sportschedule.module.scss';
import { requestYmmModal } from '@/packages/sxm/ymm/ymmModalEvent';

export default function EmptyTabsMessage(): React.JSX.Element {
    return (
        <Grid container>
            <Grid col={{ sm: 12 }}>
                <NoGames
                    logo={{
                        url: 'https://siriusxm.com/content/dam/sxm-com/logos/stella/StellaSit.png',
                        altText: '',
                        filetype: 'image/png',
                        format: 'image',
                    }}
                    title="This channel will only display if it's included in your plan"
                    classNames={sportsStyles.noGamesWrapper}
                >
                    <button type="button" onClick={requestYmmModal} className={sportsStyles.ymmButton}>
                        Verify your car&apos;s year, make and model
                    </button>
                    <Text className={sportsStyles.textStyling} tag="p">
                        {' '}
                        to ensure the correct programming is displaying for your vehicle.
                    </Text>
                </NoGames>
            </Grid>
        </Grid>
    );
}
